// ============================================================================
// FRENCH TRANSLATIONS - CHAPTER 8: LE SECOURS DU TRÈS-HAUT (BONUS)
// ============================================================================
// Niveau 92 (1 niveau bonus, 3 questions)

export const chapter8Translations = {
  name: "Le Secours du Très-Haut",
  description: "Celui qui demeure sous l'abri du Très-Haut repose à l'ombre du Tout-Puissant",
  
  spiritualWisdom: {
    principle: "Vous êtes arrivés en haut de la montagne, et la connaissance est acquise",
    scripture: "Celui qui demeure sous l'abri du Très-Haut repose à l'ombre du Tout-Puissant (Psaume 91:1)",
    application: "La foi inébranlable demande l'expérience de vie, la miséricorde et le véritable amour de Jésus. Les épreuves testeront votre cœur, le vrai chemin choisi."
  },
  
  levels: {
    92: {
      name: "L'Abri du Très-Haut",
      challenge: "Vous êtes au sommet de la montagne... Mais la foi inébranlable commence maintenant...",
      easy: {
        question: "Qui est Jésus pour vous personnellement ?",
        options: [
          "Un simple prophète",
          "Mon Seigneur et Sauveur personnel",
          "Une légende",
          "Un philosophe"
        ],
        hint: "Il est celui qui donne sa vie pour nous sauver",
        funFact: "✝️ Jésus est Dieu ! Il n'est pas qu'un personnage historique - Il est vivant et désire une relation personnelle avec chacun de nous!"
      },
      medium: {
        question: "Pourquoi jeûner comme Daniel nous permet-il de mieux entendre Dieu ?",
        options: [
          "Pour perdre du poids",
          "Pour se priver de ce qu'on aime et avoir un cœur transformé",
          "Pour impressionner les autres",
          "Pour être plus fort"
        ],
        hint: "Privez-vous de ce que vous aimez le plus, dans le calme et la sagesse",
        funFact: "🙏 Le jeûne spirituel prépare notre cœur aux transformations profondes - souvent douloureuses - qui nous rapprochent de Dieu!"
      },
      hard: {
        question: "Quelle est la véritable réponse du cœur face à toute cette connaissance acquise ?",
        options: [
          "Je suis maintenant parfait",
          "Je te donne mon cœur Jésus et je désire être baptisé",
          "Je connais mieux que les autres",
          "Je n'ai plus besoin d'aide"
        ],
        hint: "La vraie foi mène à l'abandon total et à l'engagement avec Jésus",
        funFact: "🌟✨ Vous êtes arrivés en haut de la montagne, et la connaissance est acquise ✨\n\n💖 La foi inébranlable demande de l'expérience de vie, de la miséricorde et du véritable amour de Jésus 💖\n\n🔥 Les diverses épreuves de la vie testeront votre voie, le vrai chemin que l'on choisit, notre cœur 🔥\n\n😔 Nous restons imparfaits, nos désirs sont nombreux, et l'amour du gain ou de notre confort personnel devient trop souvent notre priorité égoïste 😔\n\n🙏 Demandez à Dieu la sagesse, son amour, sa force, et reconnaissez vos faiblesses humblement, car on ne peut rien Lui cacher... Rien 🙏\n\n🥖 Jeûnez comme Daniel : privez-vous un moment de ce que vous aimez le plus, dans le calme et la sagesse 🥖\n\n💫 Cela vous permettra de mieux entendre Dieu, d'avoir une disposition de cœur prête aux transformations profondes 💫\n\n🌙 Alors, les rêves et les songes deviendront plus clairs, comme pour Joseph 🌙\n\n⚠️ Gardez-vous de l'orgueil : ne cédez pas au 'j'ai toujours raison' ou au 'je connais mieux' ⚠️\n\n🎁 Car la révélation de Dieu est une grâce extraordinaire 🎁\n\n💝 Avoir la foi, c'est entrer dans une relation et un cheminement libre du cœur 💝\n\n🦸‍♂️ Elle fera de vous des héros puissants, capables de l'impossible 🦸‍♂️\n\n✝️ Au sommet de la connaissance, le cœur sincère dit : 'Je te donne mon cœur Jésus et je désire être baptisé' ✝️\n\n🏔️ Vous êtes arrivés en haut de la montagne, accrochez-vous, persévérez ! 🏔️\n\n⬇️ Il faut redescendre et porter ce précieux trésor : l'espoir de la vie éternelle ⬇️\n\n🏆✨ BRAVO ! ON EST FIER DE TOI ✨🏆\n🌟 COURAGE VALEUREUX PORTEUR DE PAIX 🌟\n🕊️✨ QUE DIEU TE BÉNISSE ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
